module.exports = __webpack_public_path__ + "static/media/Sarah Dopf Headshot.01e76dfa.jpeg";